import { useEffect, useState } from 'react';
import { Loader } from 'lucide-react';
import { RouterProvider } from 'react-router/dom';

import BuildInfo from './components/BuildInfo';
import { TailwindIndicator } from './components/tailwind-indicator';
import { Toaster } from './components/ui/toaster';
import { TooltipProvider } from './components/ui/tooltip';
import { useAutoConnectWebSocket } from './hooks/use-autoconnect-ws';
import { useCalculateRowsPerPage } from './hooks/use-calculate-rows-per-page';
import router from './routing/router';
import { useWsClientStore } from './services/ws-client';
import { useFiltersStore } from './stores/filtersStore';

function App() {
  useAutoConnectWebSocket();
  const [isLoading, setIsLoading] = useState(true);
  const { initWorker } = useWsClientStore();
  const { setPagination } = useFiltersStore();
  const rowsPerPage = useCalculateRowsPerPage();
  useEffect(() => {
    const loadData = async () => {
      await initWorker();
      setIsLoading(false);
      setPagination({
        pageIndex: 0,
        pageSize: rowsPerPage,
      });
    };
    loadData();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="flex h-full items-center justify-center">
          <Loader className="animate-spin-slow" />
        </div>
      ) : (
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      )}
      <Toaster />
      <TailwindIndicator />
      <BuildInfo />
    </>
  );
}

export default App;
